// @LTG-ID: F-020
// @STATUS: BUILT
// @HERMETIC: false  // consumes FEATURED_JOURNALS data + internal /journals routes
// @DOCS: 08_FEATURES.md#F-020, source Landing Page.html lines 2881-2922
//        + Journals.html lines 207-242 (editor's-picks trio template).
//        Hybrid composition per ADR-012 D8 (logged in CHG-0049).
// @CHANGED: 2026-02 session_003 (CHG-0049)
// @OWNER: web
//
// F-020 — Landing-page Journals section. Section header + closing band ported
// verbatim from `Landing Page.html` lines 2885-2919; inner 3-tile trio uses the
// richer Editor's-picks pattern from `Journals.html` lines 213-239 (with status
// + deck fields), composed per ORCH-0040. All three brief links are INTERNAL —
// `<a>` to `/journals/<slug>` for the 2 published deep-dives or `/journals#brief-13`
// for the preview tile. P3 will render the actual journals route content; here
// the section exists, so click does not 404.

import { FEATURED_JOURNALS } from "../../data/featured-journals";
import ItalicPeriod from "../brand/ItalicPeriod";
import "./journals-section.css";

export function JournalsSection() {
    return (
        <section
            className="ltg-journals-section"
            id="journals"
            data-testid="journals-section"
        >
            <div className="ltg-container">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="journals-eyebrow"
                    >
                        The KGOB Journals
                    </span>
                    <h2 data-testid="journals-h2">
                        Field notes from the seat we sit in
                        <ItalicPeriod />
                    </h2>
                </div>

                <div
                    className="ltg-featured-grid"
                    data-testid="journals-featured-grid"
                >
                    {FEATURED_JOURNALS.map((j, i) => (
                        <a
                            key={j.href}
                            href={j.href}
                            className={
                                "ltg-feature-card" +
                                (j.primary ? " ltg-feature-card--primary" : "")
                            }
                            data-testid={`journals-tile-${i}`}
                        >
                            <span className="ltg-feature-card__tag">
                                {j.tag}
                            </span>
                            <h3>{j.title}</h3>
                            {j.deck && (
                                <p className="ltg-feature-card__deck">
                                    {j.deck}
                                </p>
                            )}
                            <div className="ltg-feature-card__meta">
                                <span>
                                    {j.readTime}
                                    <span className="ltg-feature-card__sep">
                                        {" · "}
                                    </span>
                                    <span
                                        className={
                                            "ltg-feature-card__status " +
                                            (j.status === "published"
                                                ? "ltg-feature-card__status--published"
                                                : "ltg-feature-card__status--preview")
                                        }
                                        data-testid={`journals-tile-${i}-status`}
                                    >
                                        {j.status}
                                    </span>
                                </span>
                                <span
                                    className="ltg-arrow"
                                    aria-hidden="true"
                                >
                                    →
                                </span>
                            </div>
                        </a>
                    ))}
                </div>

                <div className="ltg-journals-out">
                    <a
                        href="/journals"
                        className="ltg-btn ltg-btn-secondary"
                        data-testid="journals-out-link"
                    >
                        Browse every journal at letstalkgrowth.com/journals{" "}
                        <span className="ltg-arrow" aria-hidden="true">
                            →
                        </span>
                    </a>
                    <p className="ltg-journals-out__note">
                        Thirty-seven briefs across valuation, exit planning,
                        deal structures, and sector deep-dives. New playbooks
                        each month, edited under Sara F. Gonzalez, CPA.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default JournalsSection;
